
$(document).ready(function() {
    const parentDesc = $('.main-description');
    if (parent.length) {
    parentDesc.find('p').each(function() {
        if ($(this).html().trim().replace(/&nbsp;/g, '').length === 0) {
        $(this).remove();
        }
    });
    parentDesc.find('span').each(function() {
        if ($(this).html().trim().replace(/&nbsp;/g, '').length === 0) {
        $(this).remove();
        }
    });
    parentDesc.find('div').each(function() {
        if ($(this).html().trim().replace(/&nbsp;/g, '').length === 0) {
        $(this).remove();
        }
    });
    }
    $('.main-description br').remove();
    $(".main-description p:empty").remove();
    $(".main-description div:empty").remove();
    $(".main-description span:empty").remove();
    $(".main-description ul:empty").remove();
    $(".main-description li:empty").remove();
    $(".main-description strong:empty").remove();
});
